import React, { useRef } from "react";

export default function DynamicInput({
  value,
  onChange,
  name,
  className,
  placeHolder,
  index,
  readOnly,
  autoFocus,
}) {
  const refInput = useRef(null);
  return (
    <textarea
      ref={refInput}
      name={name}
      className={className}
      value={value}
      autoFocus={autoFocus}
      readOnly={readOnly}
      placeholder={placeHolder}
      onChange={(e) => {
        onChange(e, index);

        // Dynamically adjust the height based on content
        const currentInput = refInput.current;
        currentInput.style.height = "auto";
        if (!value) {
          currentInput.style.height = `15px`;
        }
        currentInput.style.height = `${
          currentInput ? currentInput.scrollHeight : 15
        }px`;
      }}
      onBlur={() => {
        // Set value to an empty string if it's null or undefined
        if (!value) {
          onChange({ target: { value: "" } }, index);
        }
      }}
      style={{
        height: "15px",
        minHeight: "18px",
        resize: "none",
        width: "100%",
        lineHeight: "100%",
        border: "0px",
        background: "transparent",
      }}
    />
  );
}
